// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"af4d3759","453":"5cda3234"}[chunkId] + ".chunk.js";
};